import b3request from './base'

export type CustomerIdType = number
export type StoreHashType = string
export type TokenType = string
export type RoleIdType = string
export type UserIdType = string
export type CompanyIdType = string
export type AddressIdType = string
export interface GetTokenRequestBody {
  bcToken: TokenType,
  customerId: CustomerIdType,
  storeHash: StoreHashType,
}
export interface GetTokenResponseBody {
  token?: string
}
export interface GetUserRoleResponseBody {
  roleId: RoleIdType
  userId: UserIdType
  email: string
}

export interface CompanyInfo {
  companyId?: CompanyIdType
  companyName?: string
  companyStatus?: string
}

export interface AddressPermission {
  isAllow: string
  isEnabled: string
}

export interface CompanyBasicInfo {
  addressLine1: string
  addressLine2: string
  catalogId: string
  catalogName: string
  city: string
  companyEmail: string
  companyId: string
  companyName: string
  companyStatus: string
  country: Country | string
  phoneNumber: string
  state: State | string
  zipCode: string
}

export interface Country {
  countryCode: string
  countryName: string
}

export interface State {
  stateCode: string
  stateName: string
}

export interface AddressInfo {
  addressId?: AddressIdType
  addressLine1: string
  addressLine2: string
  city: string
  country: Country | string
  firstName: string
  lastName: string
  phoneNumber: string
  label: string
  state: State | string
  zipCode: string
  isShipping: number
  isBilling: number
  extraFields?: any
}

export interface DefaultAddresses {
  billing: AddressInfo
  shipping: AddressInfo
}

export interface CountryGroup extends Country {
  states: State[]
}
export interface Countries {
  list: CountryGroup[]
}

export interface AddressesAll {
  addresses: {
    [id: string]: AddressInfo
  }
  defaultBillingId: string
  defaultShippingId: string
}

export interface B3PaymentMethod {
  code: string;
  isEnabled: string;
  name: string;
  paymentId: number;
}

export interface RequestPoNumber {
  orderId: string
  poNumber: string
  referenceNumber: string
  extraFields?: any
  extraInfo?: any
}

export interface RequestQuote {
  storeHash: StoreHashType
  orderId: string
}

export interface CheckoutSettingItem {
  id?: number
  type?: string
  value: string
}

export interface CheckoutSettings {
  [key: string]: CheckoutSettingItem
}

export interface RequestQuoteDetails {
  isBackendUser: string
  storeHash: string
  date: string
}

export const getToken = (data: GetTokenRequestBody): Promise<GetTokenResponseBody> => b3request.post('/api/v2/login', data)
export const getUserRole = (customerId: CustomerIdType): Promise<GetUserRoleResponseBody> => b3request.get(`/api/v2/users/${customerId}?isBcId=1`)
export const getSalesRepMasquerading = (customerId: CustomerIdType): Promise<CompanyInfo> => b3request.get(`/api/v2/sales-reps/${customerId}/companies/masquerading`)
export const getCompany = (userId: UserIdType): Promise<CompanyInfo> => b3request.get(`/api/v2/customers/${userId}/companies`)
export const getCompanyBasicInfo = (companyId: CompanyIdType): Promise<CompanyBasicInfo> => b3request.get(`/api/v2/companies/${companyId}/basic-info`)
export const getAddressPermission = (): Promise<AddressPermission> => b3request.get('/api/v2/companies/addresses/permission')
export const getDefaultAddressesByCompanyId = (companyId: CompanyIdType): Promise<DefaultAddresses> => b3request.get(`/api/v2/companies/${companyId}/default-addresses`)
export const getCountries = (): Promise<Countries> => b3request.get('/api/v2/companies/addresses/countries')
export const getAddressesAll = (companyId: CompanyIdType): Promise<AddressesAll> => b3request.get(`/api/v2/companies/${companyId}/addresses`)
export const createAddress = (companyId: CompanyIdType, data: AddressInfo): Promise<{ addressId: AddressIdType }> => b3request.post(`/api/v2/companies/${companyId}/addresses`, data)
export const beginMasqueradeCompany = (companyId: any, customerId: any) => b3request.put(`/api/v2/sales-reps/${customerId}/companies/${companyId}/begin-masq`)
export const getPaymentMethods = (companyId: CompanyIdType): Promise<B3PaymentMethod[]> => b3request.get(`/api/v2/companies/${companyId}/payments`);
export const addPoNumber = (data: RequestPoNumber) => b3request.post('/api/v2/orders', data)
export const checkoutQuote = (quoteId: string, data: any) => b3request.post(`/api/v2/rfq/${quoteId}/ordered`, data)
export const getStoreCheckoutSettings = (): Promise<CheckoutSettings> => b3request.get('/api/v2/store-configs/checkout')

export const getQuoteDetails = (quoteId: string, params: RequestQuoteDetails) => b3request.get(`/api/v2/rfq/${quoteId}`, { params })


// IP extra apis
export type IPPaymentMethod = {
  any: string
}

export type getIPPaymentMethodsResponse = {
  allowedMethods: IPPaymentMethod[]
}

export type GetIPOrderPaymentIdPayload = {
  orderId: string
}

export type GetIPOrderPaymentIdResponse = {
  paymentId: string
  receiptId: string
}
export const getIPPaymentMethods = (): Promise<getIPPaymentMethodsResponse> => b3request.get('/api/v1/ip/storefront/payments/bigcommerce/allowed-methods');
export const getIPOrderPaymentId = (data: GetIPOrderPaymentIdPayload): Promise<GetIPOrderPaymentIdResponse> => b3request.post('/api/v1/ip/storefront/payments/bigcommerce/orders', data)

export const getExtraFieldsModule = (type: string) => b3request.get(`/api/v2/extra-fields/${type}/storefront`)

export const validateExtraFieldsModule = (type: string, data: any) => b3request.post(`/api/v2/extra-fields/${type}/validate`, data)
